import { createSlice } from '@reduxjs/toolkit';

import { networkReducer, networkState } from './network';
import { sessionReducer, sessionState } from './session';
import { sideReducer, sideState } from './side';

/** Component Dialog Slice. */
export const componentDialogSlice = createSlice({
  name: 'component_dialog',
  initialState: {
    ...sideState,
    ...sessionState,
    ...networkState,
  },
  reducers: {
    ...sideReducer,
    ...sessionReducer,
    ...networkReducer,
  },
});

/** Component Dialog Slice Actions. */
export const componentDialogSliceActions = componentDialogSlice.actions;
